import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sheet } from "./Sheet.js";
export const FRAME = {
    standard: { max: 1120, margin: 170, content: 780, gap: "var(--space-7)" },
    wide: { max: 1400, margin: 150, content: 1126, gap: "44px" },
};
/**
 * The column template and the sheet's column are indirected (ADR 0036 clauses 8 and 9): the
 * component writes the wide value as the fallback and a narrow value as a second local
 * variable, and only the `data-layout="page-frame"` width query in `interactions.css`
 * re-points `--frame-cols` and `--frame-content-col` to them, stacking the margin column above
 * the content.
 */
export function PageFrame({ variant = "standard", margin, children }) {
    if (variant === "single") {
        return (_jsx("div", { "data-layout": "page-frame", "data-frame": "single", style: {
                maxWidth: 1120, minHeight: "100%", margin: "0 auto",
                padding: "var(--space-15) var(--space-5) 0",
                display: "flex", flexDirection: "column", boxSizing: "border-box",
            }, children: _jsx(Sheet, { "data-frame-content": "", style: { flex: 1, minWidth: 0, padding: "var(--space-4) var(--space-4) var(--space-10)" }, children: children }) }));
    }
    if (variant === "narrow") {
        return (_jsx("div", { "data-layout": "page-frame", "data-frame": "narrow", style: {
                minHeight: "100%", padding: "var(--space-025) var(--space-5) 0",
                display: "flex", flexDirection: "column", boxSizing: "border-box",
            }, children: _jsx(Sheet, { "data-frame-content": "", style: {
                    flex: "1 0 auto", boxSizing: "border-box", width: 624, maxWidth: "100%", margin: "0 auto",
                    padding: "var(--space-4) var(--space-4) var(--space-10)",
                }, children: children }) }));
    }
    const f = FRAME[variant];
    return (_jsxs("div", { "data-layout": "page-frame", "data-frame": variant, style: {
            "--frame-cols-narrow": "minmax(0, 1fr)",
            "--frame-content-col-narrow": "1",
            maxWidth: f.max, minHeight: "100%", margin: "0 auto",
            padding: "var(--space-5) var(--space-5) 0",
            display: "grid",
            gridTemplateColumns: `var(--frame-cols, ${f.margin}px minmax(0, ${f.content}px))`,
            columnGap: f.gap,
        }, children: [_jsx("div", { "data-frame-margin": "", style: { minWidth: 0 }, children: margin }), _jsx(Sheet, { "data-frame-content": "", style: {
                    gridColumn: "var(--frame-content-col, 2)",
                    minWidth: 0,
                    margin: "calc(var(--space-15) - var(--space-5)) calc(var(--space-4) * -1) 0",
                    padding: "calc(var(--space-5) - var(--space-15)) var(--space-4) var(--space-10)",
                }, children: children })] }));
}
